import React from "react";
import { Location } from "../Location";
import { ContractBookingForm } from "@consultants/ConsultantBookingContract/ContractBookingForm";

interface Params {
  consultantId: string;
  contractId: string;
  action: string;
}

export class ConsultantBookingContractEditorLocation extends Location<Params> {
  constructor(consultantId: string, contractId: string, action: string) {
    super({ consultantId, contractId, action });
  }

  render(): React.ReactElement<any> {
    return (
      <ContractBookingForm
        consultantId={this.params.consultantId}
        contractId={this.params.contractId}
        action={this.params.action}
      />
    );
  }

  toURI() {
    const { consultantId, contractId } = this.params;
    return `/consultants/${consultantId}/customer_contract/${contractId || "new"} `;
  }
}
